import { Component } from '@angular/core';
import { IntegrationCompany } from 'sharedGuiSmall/enums';
import { RedirectGlobalService } from 'sharedGuiSmall/sharedServices/redirectGlobal.service';

@Component({
    selector: 'crunch-sign-up',
    templateUrl: './crunch-sign-up.component.html',
    styleUrls: ['./crunch-sign-up.component.less']
})
export class CrunchSignUpComponent {
    
    createAccountButtonText = $localize`CREATE_A_FREE_BRIXX`;

    constructor(private redirectService: RedirectGlobalService) {
        // BR-9170 redirect app.brixx.com/crunch-sign-up to app.brixx.com/sign-up/trial 
        location.href = "/sign-up/trial";
    }

    getNews = false;

    toggleGetNews() {
        this.getNews = !this.getNews;
    }

    crunchSignUp() {
        this.redirectService.redirectToIntegrator(IntegrationCompany.Crunch, this.getNews);
    }

    goToMainSite(): void {
        window.location.href = "https://www.brixx.com";
    }
}